"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeYearDateFormat = exports.dayMonthDateFormat = exports.convertMilliseconds = void 0;
var dayMonthDateFormat = function dayMonthDateFormat(date) {
  var regexWeekDay = /.*, /;
  var regexYear = / -.*/;
  return date.replace(regexWeekDay, '').replace(regexYear, '');
};
exports.dayMonthDateFormat = dayMonthDateFormat;
var removeYearDateFormat = function removeYearDateFormat(date) {
  var regex = / -.* /;
  return date.replace(regex, ' · ');
};
exports.removeYearDateFormat = removeYearDateFormat;
var convertMilliseconds = function convertMilliseconds(milliseconds) {
  var day, hour, minute, seconds;
  seconds = Math.floor(milliseconds / 1000);
  minute = Math.floor(seconds / 60);
  seconds = seconds % 60;
  hour = Math.floor(minute / 60);
  minute = minute % 60;
  day = Math.floor(hour / 24);
  hour = hour % 24;
  return {
    day: day,
    hour: hour,
    minute: minute,
    seconds: seconds
  };
};
exports.convertMilliseconds = convertMilliseconds;
//# sourceMappingURL=dateFormat.js.map